import { ServiceBase } from '../../../../core/services/ServiceBase'
import SummaryProxy from './SummaryProxy'

class SummaryService extends ServiceBase {
  getTemplates(params) {
    return this.getData(() => SummaryProxy.getTemplates(params))
  }
  getTemplateDetail(params) {
    return this.getData(() => SummaryProxy.getTemplateDetail(params))
  }
  setDefaultTemplate(params) {
    return this.getData(() => SummaryProxy.setDefaultTemplate(params), true)
  }
  deleteTemplates(params) {
    return this.getData(() => SummaryProxy.deleteTemplates(params), true)
  }
  updateTemplate(params) {
    return this.getData(() => SummaryProxy.updateTemplate(params), true)
  }
  saveTemplate(params) {
    return this.getData(() => SummaryProxy.saveTemplate(params), true)
  }
  getDefaultTemplate(params) {
    return this.getData(() => SummaryProxy.getDefaultTemplate(params))
  }
  getSummaryHighlight(params) {
    return this.getData(() => SummaryProxy.getSummaryHighlight(params))
  }
  getSummaryOverview(params) {
    return this.getData(() => SummaryProxy.getSummaryOverview(params))
  }
  getOwnershipAndGroupInfo(params) {
    return this.getData(() => SummaryProxy.getOwnershipAndGroupInfo(params))
  }
  getOwnershipAndGroup(params) {
    return this.getData(() => SummaryProxy.getOwnershipAndGroup(params))
  }
  getKeyFinancials(params) {
    return this.getData(() => SummaryProxy.getKeyFinancials(params))
  }
  getScore(params) {
    return this.getData(() => SummaryProxy.getScore(params))
  }
  getRecentNews(params) {
    return this.getData(() => SummaryProxy.getRecentNews(params))
  }
  getAlertHighlight(params) {
    return this.getData(() => SummaryProxy.getAlertHighlight(params))
  }
  getCompanyAlerts(params) {
    return this.getData(() => SummaryProxy.getCompanyAlerts(params))
  }
  getRevenue(params) {
    return this.getData(() => SummaryProxy.getRevenue(params))
  }
  getIndustryTopYear(params) {
    return this.getData(() => SummaryProxy.getIndustryTopYear(params))
  }
  getTopIndustryPlayers(params) {
    return this.getData(() => SummaryProxy.getTopIndustryPlayers(params))
  }
  getFilingStatus(params) {
    return this.getData(() => SummaryProxy.getFilingStatus(params))
  }
}

export default new SummaryService()
